<!-- 上传图片组件 -->
<template>
  <div class="upload">
    <a-upload
      name="files"
      v-model:file-list="fileList"
      :action="action"
      :headers="header"
      :data="dataForm"
      :list-type="listType"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
    >
      <div v-if="fileList.length < maxLength">
        <auth-img mode="ant" :width="28" :height="28" :src="upload" :preview="false" />
        <div class="num">{{ ` ${fileList?.length ?? 0}/${maxLength}` }}</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <auth-img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script setup>
import { defineProps, ref, defineEmits, watch } from 'vue'
import { message } from 'ant-design-vue'
import upload from '@/assets/img/orderInspection/upload.png'
import store from '@/store'
import { isArray } from 'lodash'
const header = {
  token: store.getters.token
}
const dataForm = {
  type: '1'
}
const prop = defineProps({
  action: {
    type: String,
    required: false,
    default: process.env.VUE_APP_BASE_API + '/file/upload/batch'
  },

  listType: {
    type: String,
    default: 'picture-card'
  },
  maxLength: {
    type: Number,
    default: 9
  },
  accept: {
    // 支持的文件类型
    type: Array,
    default: () => ['image/jpeg', 'image/png']
  },
  maxSize: {
    // 支持的图片大小
    type: Number,
    default: 10
  },
  files: {
    // 已经上传的文件列表（受控）
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['onSuccess'])
const previewVisible = ref(false)
const previewImage = ref('')
const fileList = ref([])
const handlePreview = async file => {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj)
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
}
const handleChange = ({ file, fileList: newFileList }) => {
  const status = file?.status
  if (status === 'done' || status === 'removed') {
    if (!isArray(newFileList)) {
      newFileList = [newFileList]
    }
    const list = newFileList
      ?.map(item => (item.response && item.response.data && item.response.data[0]) || item?.url)
      .filter(Boolean)
    emit('onSuccess', list)
  } else if (status === 'error') {
    message.error('文件上传失败')
  }
}
const beforeUpload = file => {
  return new Promise((resolve, reject) => {
    const isLtSize = file.size / 1024 / 1024 < prop.maxSize
    const isSupportType = prop.accept.includes(file.type)
    if (!isLtSize) {
      message.error(`请上传${prop.maxSize}MB以内的图片`)
      reject()
    } else if (!isSupportType) {
      message.error('请上传 JPG/PNG 格式图片!')
      reject()
    } else {
      resolve()
    }
  })
}
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
watch(
  () => prop.files,
  val => {
    fileList.value =
      val?.map((item, index) => {
        return {
          uid: index,
          name: 'image.png',
          status: 'done',
          url: item
        }
      }) ?? []
  },
  { deep: true, immediate: true }
)
</script>
<style scoped lang="scss">
.upload {
  .num {
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
  ::v-deep(.ant-upload-picture-card-wrapper) {
    .ant-upload.ant-upload-select-picture-card {
      width: 60px;
      height: 60px;
      border: 1px dashed rgba(153, 153, 153, 0.3);
      border-radius: 8px;
      margin: 0 0 12px 0;
      .ant-upload {
        padding: 0;
      }
    }

    .ant-upload-list-picture-card-container {
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin: 0 12px 12px 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    .ant-upload-list-picture-card .ant-upload-list-item {
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin: 0;
      padding: 0;
      border: none;
      overflow: hidden;
    }
  }
  .upload_icon svg {
    width: 24px;
    height: 24px;
    color: #999999;
  }
  .ant-upload-text {
    font-weight: 300;
    font-size: 12px;
    transform: scale(0.83);
    color: #999999;
  }
}
</style>
